<div class="bg-card-light dark:bg-card-dark p-6 rounded-xl border border-gray-200 dark:border-gray-800 shadow-sm">
  <h3 class="text-lg font-bold font-display text-gray-700 dark:text-white mb-4">My Favorites</h3>
  <ul *ngIf="favorites.length > 0; else noFavorrites" class="space-y-3">
    <li *ngFor="let fav of favorites" class="flex items-center gap-3 group cursor-pointer" (click)="openVideo(fav)">
      <span class="material-symbols-outlined text-primary">
        {{ fav.type === 'video' ? 'videocam' : 'description' }}
      </span>
      <div class="flex-1">
        <p class="text-sm text-gray-700 dark:text-gray-300 group-hover:text-primary dark:group-hover:text-primary transition-colors truncate">
          <span class="font-semibold">{{ fav.application }}:</span> {{ fav.title }}
        </p>
        <p class="text-xs text-gray-400 dark:text-gray-500">Uploaded: {{ fav.uploaded }}</p>
      </div>
      <span class="material-symbols-outlined text-accent/80">star</span>
    </li>
  </ul>
  <ng-template #noFavorrites>
    <p class="text-sm text-gray-500 dark:text-gray-400">
      You have no favorite items yet.
    </p>
  </ng-template>
</div>